import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { APP_CONFIG } from 'app/core/config/app-config.token';

@Injectable({ providedIn: 'root' })
export class HelpCentreService {
  private readonly http = inject(HttpClient);
  private readonly appConfig = inject(APP_CONFIG);

  /**
   * Opens a Help Centre article in a new tab.
   * Requests a fresh token on every call — tokens are single-use.
   *
   * @param articleSlug  The WP article slug, e.g. "getting-started".
   */
  openArticle(articleSlug: string): void {
    const tokenUrl = `${this.appConfig.serverUrl}/auth/helpCentreToken`;
    const dest = encodeURIComponent(`/${articleSlug}`);
    this.http.get<{ token: string }>(tokenUrl).subscribe({
      next: ({ token }) => {
        const url =
          `${this.appConfig.helpCentreBase}/` +
          `?esqep_sso=1&esqep_token=${encodeURIComponent(token)}&dest=${dest}`;
        window.open(url, '_blank', 'noopener,noreferrer');
      },
      error: () =>
        window.open(
          this.appConfig.helpCentreFallbackUrl,
          '_blank',
          'noopener,noreferrer',
        ),
    });
  }
}
